module.exports = __webpack_public_path__ + "static/media/retornavel-desktop.deaa1c42.jpg";